import { MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#040810] border-t border-white/5 pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 border border-gold flex items-center justify-center">
                <div className="w-2 h-2 bg-gold rotate-45" />
              </div>
              <span className="font-heading text-lg text-white">
                Direct<span className="text-gold">Fund</span>Cap
              </span>
            </div>
            <p className="text-white/50 max-w-md leading-relaxed">
              Direct in-house funding plus a vetted network of top-tier lenders.
              Speed, transparency, and capital that actually moves your business —
              without the bank runaround.
            </p>
            <div className="mt-8 space-y-3 text-sm">
              <div className="flex items-center gap-3 text-white/70">
                <MapPin className="w-4 h-4 text-gold" /> New York, NY
              </div>
              <a href="#apply" className="inline-flex items-center gap-2 text-gold hover:text-gold-400 link-underline">
                Reach us via the application form →
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs tracking-[0.2em] uppercase font-bold text-gold mb-5">Funding</div>
            <ul className="space-y-3 text-sm text-white/60">
              {["Merchant Cash Advance", "Revenue-Based Financing", "Term Loans", "Business Line of Credit"].map((l) => (
                <li key={l}><a href="#products" className="hover:text-white">{l}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs tracking-[0.2em] uppercase font-bold text-gold mb-5">Company</div>
            <ul className="space-y-3 text-sm text-white/60">
              <li><a href="#how" className="hover:text-white">How It Works</a></li>
              <li><a href="#industries" className="hover:text-white">Industries</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
              <li><a href="/admin/login" className="hover:text-white">Partner Login</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} DirectFundCap, LLC. All rights reserved.</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a href="#" className="hover:text-gold">Privacy Policy</a>
            <a href="#" className="hover:text-gold">Terms of Service</a>
            <a href="#" className="hover:text-gold">Disclosures</a>
            <a href="#" className="hover:text-gold">Compliance</a>
          </div>
        </div>

        <div className="mt-10 text-[10px] text-white/30 leading-relaxed max-w-4xl">
          DirectFundCap is a financial technology company offering small business funding products through its in-house capital
          and a network of licensed lending partners. Funding amounts, rates, and terms are subject to applicant qualifications,
          state regulations, and final underwriting approval. Same-day funding availability depends on time of submission, completeness
          of documentation, and receiving bank's processing times. DirectFundCap does not guarantee approval or specific terms.
          Soft credit checks do not affect your personal credit score; a hard credit pull may occur only with applicant consent
          prior to closing.
        </div>

        <div className="mt-12 -mb-2 select-none overflow-hidden">
          <div className="font-heading text-[18vw] leading-none tracking-[-0.05em] text-white/[0.03] whitespace-nowrap">
            DIRECTFUNDCAP
          </div>
        </div>
      </div>
    </footer>
  );
}
